import React from "react"
//import components
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import ContactsTable from "./ContactsTable"
import { useTranslation } from "react-i18next"

export default function ContactsList() {

  const { t } = useTranslation()
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Contacts")} />
        <ContactsTable />
      </div>
    </div>
  )
}
